import { createVariant } from '../../utils/createVariant';
export const LabelText = createVariant({
    name: 'label-text',
    tagName: 'p',
    baseStyle: ({ theme }) => (Object.assign(Object.assign({}, theme.typography.labels['75LabelTextMobile']), { color: theme.colors.blanc.textButton })),
    responsiveStyles: ({ theme }) => [
        [theme.viewportBreakpoint.lg, theme.typography.labels['75LabelText']],
    ],
});
